import React, { useEffect } from "react";
import "./Journey.css";

import IgniteNavbar from "../../layout/IgniteNavbar";
import IgniteHeader from "../../layout/IgniteHeader";

import JourneyHero from "./Components/JourneyHero";
import JourneyProgressCard from "../IgniteDashboard/Components/JourneyProgressCard";
import CurrentLevelCard from "./Components/CurrentLevelCard";
import NextLevelCard from "./Components/NextLevelCard";
import JourneyTimeline from "./Components/JourneyTimeline";
import LevelObjectivesCard from "../IgniteDashboard/Components/LevelObjectivesCard";

import VaultProgressCard from "../IgniteDashboard/Components/VaultProgressCard";

const Journey = () => {
     useEffect(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, []);
 // Hide website footer
  useEffect(() => {
    const navbar = document.querySelector("header, .navbar");
    const footer = document.querySelector("footer");
  
   
    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";
  
    return () => {
      // 🔥 மீண்டும் restore
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);
    return (

        <div className="ignite-journey">

            <IgniteNavbar />

            <main className="ignite-journey-main">

                <IgniteHeader

                    title="Journey"

                    subtitle="Track your progress and unlock your next level."

                />

                <JourneyHero />

                <div className="journey-row">

                    <JourneyProgressCard />

                </div>

                <div className="journey-row two-column">

                    <CurrentLevelCard />

                    <NextLevelCard />

                </div>

                <div className="journey-row">

                    <JourneyTimeline />

                </div>

                <div className="journey-row">

                    <LevelObjectivesCard />

                </div>

                

                <div className="journey-row">

                    <VaultProgressCard />

                </div>

            </main>

        </div>

    );

};

export default Journey;